import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=4a8d2a88&scoped=true&isFirst&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isFirst&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isFirst&isPage"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d2a88",
  null
  
)

export default component.exports